import { render, staticRenderFns } from "./cif.vue?vue&type=template&id=1abc0e3b"
import script from "./cif.vue?vue&type=script&lang=js"
export * from "./cif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports